import { Address } from './address';
import { TypeEntreprise } from './typeEntreprise';

export class Employeur {
	id: number;
	nomStructure: string;
	addressStructure: Address;
	typeEntreprise: TypeEntreprise;
	siret: string;
	codeNaf: string;
	lastNameContact1: string;
	firstNameContact1: string;
	fonctionContact1: string;
	telephoneContact1: string
	emailContact1: string;
	lastNameContact2: string;
	firstNameContact2: string;
	fonctionContact2: string;
	telephoneContact2: string
	emailContact2: string;

	constructor(
		options: {
			id?: number;
			nomStucture?: string;
			addressStructure?: Address;
			typeEntreprise?: TypeEntreprise;
			lastNameContact1?: string;
			firstNameContact1?: string;
			fonctionContact1?: string;
			telephoneContact1?: string
			emailContact1?: string;
			lastNameContact2?: string;
			firstNameContact2?: string;
			fonctionContact2?: string;
			telephoneContact2?: string
			emailContact2?: string;
		} = {}
	) {
		this.id = options.id || null;
		this.nomStructure = options.nomStucture || null;
		this.addressStructure = options.addressStructure || new Address();
		this.typeEntreprise = options.typeEntreprise || new TypeEntreprise();
	}
}
